/**
 * @constructor
 * @param {jQuerySelector?} viewSelector
 * @extends {Foundation.Promise}
 * @implements {Foundation.View.Interface.ModalDialog}
 */
Foundation.View.Desktop.Fancybox = function (viewSelector) {
    Foundation.Promise.call(this);

    /** @type {!Foundation.Promise} */
    this.closedPromise = new Foundation.Promise();

    /** @type {Object.<string,*>} */
    this.fancyboxOptions = {
        "onComplete": this.fulfill.bind(this),
        "onCancel": this.fail.bind(this),
        "onClosed": this.closedPromise.fulfill.bind(this.closedPromise),
        "scrolling": "no"
    };

    /** @type {jQuery} */
    this.view = null;
    this.setView(viewSelector);
};
Foundation.inherit(Foundation.View.Desktop.Fancybox, Foundation.Promise);

Foundation.View.Desktop.Fancybox.prototype.closed = function () {
     return this.closedPromise;
};

Foundation.View.Desktop.Fancybox.prototype.setView = function (viewSelector) {
    Foundation.documentReady.then(function () {
        if (!viewSelector) {
            jQuery.fancybox.showActivity();
        }
        else {
            var highestZIndex = Foundation.View.highestZIndexFor("body");
            Foundation.extend(this.fancyboxOptions, {"content": viewSelector});
            this.view = jQuery(viewSelector);
            jQuery.fancybox(this.fancyboxOptions);
            jQuery("#fancybox-overlay").css("zIndex", highestZIndex + 1);
            jQuery("#fancybox-wrap").css("zIndex", highestZIndex + 1);
        }
    }.bind(this));
};

/**
 * Close the currently open Fancybox.
 */
Foundation.View.Desktop.Fancybox.prototype.close = function () {
    this.then(function () {
        jQuery.fancybox.close();
    });
};

/**
 * Recenter and resize the currently open Fancybox.
 */
Foundation.View.Desktop.Fancybox.prototype.redraw = function () {
    this.then(function () {
        var newWidth = this.view.not("style").outerWidth();
        jQuery("#fancybox-wrap").width(newWidth + 20);
        jQuery("#fancybox-content").width(newWidth);
        jQuery.fancybox.resize();
        jQuery.fancybox.center();
    }.bind(this));
};

/**
 * Show Fancybox's activity spinner.
 */
Foundation.View.Desktop.Fancybox.showLoading = function () {
    Foundation.documentReady.then(function () {
        jQuery.fancybox.showActivity();
    });
};

/**
 * Hide Fancybox's activity spinner.
 */
Foundation.View.Desktop.Fancybox.hideLoading = function () {
    Foundation.documentReady.then(function () {
        jQuery.fancybox.hideActivity();
    });
};
